import React from "react";
import MuiTable from "@mui/material/Table";
import clsx from "clsx";

import { useStyles } from "./Table.styles";
import { TableProps } from "./Table.types";

function Table(props: TableProps) {
  const {
    className: classNameProp,
    headerBg,
    sidePadding,
    layoutFixed,
    hideLastRowBorder,
    showBorderTop,
    borderless,
    ...other
  } = props;

  const classes = useStyles(props);

  const className = clsx(classNameProp, classes.root, {
    [classes.layoutFixed]: layoutFixed,
    [classes.hideLastRowBorder]: hideLastRowBorder,
    [classes.borderless]: borderless,
    [classes.showBorderTop]: showBorderTop,
  });

  return <MuiTable {...other} className={className} />;
}

export default Table;
